import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { FilmThumbnailSkeleton, FilmThumbnailUI } from './subcomponents/ui';
import { defaultFilmThumbnailProps, filmThumbnailPropsValidator } from './types/props';
export const FilmThumbnail = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { config, cdnOptions, events } = props;
    const { film } = useFilmContext();
    if (!film) {
        return enableSkeletonLoadingIndicators ? _jsx(FilmThumbnailSkeleton, { mediaType: config.mediaType }) : null;
    }
    return _jsx(FilmThumbnailUI, { film: film, config: config, cdnOptions: cdnOptions.filmThumbnailImage, events: events });
});
FilmThumbnail.displayName = 'FilmThumbnail';
/**
 * The **Film Thumbnail** component renders a film's thumbnail.
 */
export const FilmThumbnailComponent = withComponentWrapper(FilmThumbnail, defaultFilmThumbnailProps, filmThumbnailPropsValidator);
